/** Utilities for normalizing inclusion-criteria accordion points. */

/**
 * Expand dash-delimited sub-points embedded in the first criterion paragraph.
 * A dash is treated as a separator only when it begins the text or has
 * whitespace on both sides, so clinical terms and ranges remain intact.
 *
 * @param points - Criterion paragraph followed by any existing standalone points
 * @returns Individual display points in their original order
 */
export function expandFirstInclusionCriteriaPoint(
  points: string[],
): string[] {
  if (points.length === 0) return [];

  const [firstPoint, ...remainingPoints] = points;
  const expandedFirstPoint = firstPoint
    .trim()
    .split(/(?:^|\s+)-\s+/)
    .map((point) => point.trim())
    .filter(Boolean);

  return [
    ...expandedFirstPoint,
    ...remainingPoints.map((point) => point.trim()).filter(Boolean),
  ];
}
